import React from 'react';

import {
  Link,
  Button as BaseButton
} from '@mui/material';



export interface IProps {
  href?: string;
  color?: string;
  outlined?: boolean;

  children?: React.ReactNode | React.ReactNode[];
  onClick?: () => void;
}

export const Text: React.FC<IProps> = props => {
  return (
    <Link
      sx={{ color: props.color ? props.color : theme => theme.palette.primary.main }}
      style={{ cursor: props.onClick ? 'pointer' : 'auto' }}
      href={props.href}
      target='_blank'
      rel='noopener noreferrer'
      onClick={props.onClick}>
      {props.children}
    </Link>
  );
};



export const Button: React.FC<IProps> = props => {
  return props.href ? (
    <BaseButton
      variant={props.outlined ? 'outlined' : 'contained'}
      href={props.href}
      target='_blank'
      rel='noopener noreferrer'
      onClick={props.onClick}>
      {props.children}
    </BaseButton>

  ) : (
    <BaseButton
      variant={props.outlined ? 'outlined' : 'contained'}
      onClick={props.onClick}>
      {props.children}
    </BaseButton>
  );
};
